const months = [
    "ene",
    "feb",
    "mar",
    "abr",
    "may",
    "jun",
    "jul",
    "ago",
    "sep",
    "oct",
    "nov",
    "dic",
];

const holidays = [
    "12/10/2023",
    "1/11/2023",
    "6/12/2023",
    "8/12/2023",
    "25/12/2023",
];

let processingDays = 1
let mercado = 'es'
let minimum = 199
let minimumText = '199,00€'
if(ShopifyAnalytics.meta.product.type == 'Pendientes'){
  minimum = 40
  minimumText = '40,00€'
}
let priceItem = parseFloat(document.querySelector('.price-item--regular').textContent.trim().replace(/[$€]/g, '').replace(/,/g, '.'))

//MERCADO ESTADOS UNIDOS
if (document.URL.includes('-us/')) {
    processingDays = 7
    mercado = 'us'
}
//MERCADO EUROPA
if (document.URL.includes('-eu/')) {
    processingDays = 4
    mercado = 'eu'
}
//MERCADO RESTO DEL MUNDO
if (document.URL.includes('-rm/')) {
    processingDays = 7
    mercado = 'rm'
}

const now = new Date();
let today = new Date(now.getTime() + 24 * processingDays * 60 * 60 * 1000);
let tomorrow = false;
let other = false;
let envio = null;

//DOMINGO
other = true;
if (now.getDay() == 0) {
    envio = new Date(today.getTime() + 24 * 1 * 60 * 60 * 1000);
}
//SÁBADO
else if (now.getDay() == 6) {
    other = true;
    envio = new Date(today.getTime() + 24 * 2 * 60 * 60 * 1000);
} else if (now.getDay() == 5) {
    //VIERNES ANTES DE LAS 14H
    if (now.getHours() >= 14 && now.getMinutes() < 59) {
        other = true;
        envio = new Date(today.getTime() + 24 * 3 * 60 * 60 * 1000);
    }
    //VIERNES MÁS DE LAS 14H
    else {
        envio = new Date(today.getTime() + 24 * 2 * 60 * 60 * 1000);;
    }
} else if (now.getDay() == 4) {
    //JUEVES DESPUÉS DE LAS 14H
    if (now.getHours() >= 14 && now.getMinutes() < 59) {
        tomorrow = true;
        envio = new Date(today.getTime() + 24 * 3 * 60 * 60 * 1000);
    }
    //JUEVES
    else {
        envio = today;
    }
} else {
    //DÍA NORMAL DESPUÉS DE LAS 14H
    if (now.getHours() >= 14 && now.getMinutes() < 59) {
        tomorrow = true;
        envio = new Date(today.getTime() + 24 * 1 * 60 * 60 * 1000);
    }
    //DÍA NORMAL
    else {
        envio = today;
    }
}
const day = envio.getDate();
const month = months[envio.getMonth()];

if (holidays.includes(envio.toLocaleDateString("es"))) {
    tomorrow = false;
    if (envio.getDay() == 5) {
        envio = new Date(envio.getTime() + 24 * 3 * 60 * 60 * 1000);
    } else {
        envio = new Date(envio.getTime() + 24 * 1 * 60 * 60 * 1000);
    }
}

if (envio.getDay() == 6) {
    envio = new Date(envio.getTime() + 24 * 2 * 60 * 60 * 1000);
}
if (envio.getDay() == 0) {
    envio = new Date(envio.getTime() + 24 * 1 * 60 * 60 * 1000);
}

document.querySelector('.entrega').innerHTML =
    `Entrega estimada ${tomorrow && !other ? "mañana" : other ? "el " + envio.getDate() + " de " + months[envio.getMonth()] + "." : ''}`

if(mercado=='es'){
	document.querySelector('.entrega-title').innerHTML = `ENVÍO GRATIS ${priceItem >= minimum ? '' : 'A PARTIR DE ' + minimumText}`
}